import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-mx-auto width-max q-mb-md" }

import { SafaIcon } from "@/components/common/display";

/**
 * Presents the page within a card containing SAFA title, a slot for a form,
 * and a slot for its actions.
 */
const __default__ = {
  name: "CardPage",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "bg-background full-height row items-center justify-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        flat: "",
        bordered: "",
        class: "q-pa-sm card-page"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-pb-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(SafaIcon))
              ]),
              _renderSlot(_ctx.$slots, "form")
            ]),
            _: 3
          }),
          _createVNode(_component_q_card_actions, { class: "q-px-md" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "actions")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})